module.exports = __webpack_public_path__ + "img/2.cfe26962.png";